<div class="main">
  <p>Are you sure you want to logout?</p>
  <div class="flex-button">
    <button
      mat-button
      color="secondary"
      style="
        width: 100px;
        height: 40px;
        padding: 10px, 0px, 10px, 0px;
        border-radius: 5px;
        border: 0.72px;
        color: #00498f;
        background: #ffff;
      "
      (click)="onCancelClick()"
    >
      Cancel
    </button>
    <button
      mat-button
      color="primary"
      style="
        width: 100px;
        height: 40px;
        padding: 10px, 0px, 10px, 0px;
        border-radius: 5px;
        border: 0.72px;
        background: #00498f;
        color: #ffff;
      "
      (click)="logout()"
    >
      Logout
    </button>
  </div>
</div>
